<template>
  <el-container class="box">
    <div class="headerCom set-public-flex">
      <publicBreadCrumb :breadList="breadList" />
      <el-button type="primary" size="mini" @click="handleAdd">新增</el-button>
    </div>
    <el-main class="organization">
      <!-- 内容 -->
      <div class="organization-content-box">
        <el-table :data="list" size="small" border style="height: 100%;">
          <el-table-column label="序号" width="60" fixed>
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="type" label="协议名称">
            <template slot-scope="scope">
              {{ agreementTypeArr[scope.row.type - 1] }}
            </template>
          </el-table-column>
          <el-table-column prop="pdfName" label="PDF" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div v-if="scope.row.pdfName" @click="handlePreviewPdf(scope.row)" class="pdf-column">
                <img src="../../assets/images/pdf.png" style="margin-right:18px" />
                <span>{{ scope.row.pdfName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="version" label="协议版本号"></el-table-column>
          <el-table-column prop="updateTime" label="最后更新时间" width="167"></el-table-column>
          <el-table-column prop="updateUserId" label="最后更新用户"></el-table-column>
          <el-table-column prop="platformName" label="对应平台"></el-table-column>
          <el-table-column label="对应项目">
            <template slot-scope="scope">{{ scope.row.project }}</template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="showUpdate(scope.row)" type="text" size="small">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 修改弹框-->
      <el-dialog :title="isUpdate ? '更新协议' : '新增协议'" :visible.sync="dialogFormVisible" width="80%">
        <el-form ref="agreeForm" :model="updateData" :rules="formRules" :label-width="'160px'" size="medium">
          <el-form-item label="对应平台" required>
            <el-select v-model="platformId" placeholder="请选择" :disabled="selectRow.platformId ? true : false">
              <el-option :label="item.name" :value="item.id" v-for="(item, index) in hospitalList"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="对应项目" required>
            <el-select v-model="projectId" placeholder="请选择" :disabled="selectRow.project ? true : false">
              <el-option :label="item.label" :value="item.value" v-for="(item, index) in projectList"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="协议类型" required>
            <el-select v-model="updateData.type" placeholder="请选择" :disabled="selectRow.type ? true : false">
              <el-option :label="item.name" :value="item.code" v-for="(item, index) in agreementTypeList"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="updateData.type == 9" label="机构团队" required>
            <el-select v-model="updateData.doctorTeamId" placeholder="请输入机构团队" filterable remote
              :remote-method="getDoctorTeamIdList" :loading="getDoctorTeamLoading"
              :disabled="selectRow.doctorTeamId ? true : false">
              <el-option v-for="(item, index) in doctorTeamList" :key="index"
                :label="`${item.name}（${item.hospitalName}）`" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="协议内容" required>
            <!-- <div id="tool-editor" style="margin:0 auto"></div> -->
            <wangeditorNew :formData="updateData" :index="0" :isCheck="dialogFormVisible" @content="contentChange"
              v-if="dialogFormVisible"></wangeditorNew>

          </el-form-item>
          <el-form-item label="上传附件协议（PDF):">
            <el-upload class="avatar-uploader" action="/api/dsicm-contact-platform/feign/file/upload"
              :before-upload="beforeAvatarUpload" :headers="headers" :data="{ path: 'dsicm-useragreement' }"
              :show-file-list="false" :on-success="handleChange">
              <!-- <img v-if="pdfName" :src="checkFormData.imageUrl" class="avatar"> -->
              <img v-if="pdfName" src="../../assets/images/pdf.png" style="margin-right:18px" />
              <span v-if="pdfName" style="vertical-align:top">{{
                pdfName
              }}</span>
              <el-button v-else size="small" class="add-item" type="primary">
                + 上传附件</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="协议版本号" prop="inputVersion">
            <el-input type="number" style="width:247px" placeholder="请输入协议版本号" v-model="updateData.inputVersion">
            </el-input>
            <span v-if="updateData.id" style="display:inline-block;margin-left:20px">(当前版本：{{ this.updateData.version
              }})</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="save()">确 定</el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import { DEEP_CLONE } from "@/utils/constants";
import {
  api_list,
  api_update,
  getHospitalList,
  add_api_detail,
  api_UserAgreementTypeEnum
} from "@/api/UserAgreementApi.js";
import {
  api_doctor_team_search,
} from "@/api/doctorTeam.js";
import wangeditorNew from '@/components/wangeditorNew/index.vue'
export default {
  components: {
    wangeditorNew,
  },
  data() {
    let validateVersion = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入协议版本号或版本号输入有误"));
      } else {
        let reg = /^([1-9]+[\d]*(.[0-9]{1,2})?)$/;
        if (!reg.test(value)) {
          callback(new Error("限制数字且最多保留两位小数"));
        } else if (this.updateData.id) {
          if (this.updateData.version >= value) {
            callback(new Error("最新协议版本号，需要大于当前版本号"));
          }
        } else {
          callback();
        }
      }
    };
    return {
      breadList: [{ name: '系统设置' }, { name: '用户协议' }],
      formRules: {
        inputVersion: [
          {
            required: true,
            validator: validateVersion,
            trigger: ["change", "blur"]
          }
          // { pattern: /^([1-9]+[\d]*(.[0-9]{1,2})?)$/, message: '限制数字且最多保留两位小数', trigger: ['change', 'blur'] }
        ]
      },
      isUpdate: false,
      selectRow: {},
      agreementTypeArr: [],
      agreementTypeList: [],
      projectList: [
        {
          value: 'dsicm',
          label: '非STI专项',
        },
        {
          value: 'sti',
          label: 'STI专项',
        },
      ],
      ossUrl: "",
      platformId: "",
      projectId: '',
      hospitalList: [],
      pdfUrl: "",
      pdfName: "",
      headers: {
        Authorization: localStorage.getItem("Authorization")
      },

      dialogFormVisible: false,
      editor: null,
      list: [],
      updateData: {
        id: 0,
        text: '',
        type: '',
        doctorTeamId: '',
        inputVersion: '',
        version: '',
        content: ''
      },
      getDoctorTeamLoading: false,
      doctorTeamList: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.querInitList();
  },
  mounted() {
    this.getList();
  },
  methods: {
    // // 切换协议清空协议内容
    // changeType() {
    //   this.editor.txt.html('')
    // },
    handlePreviewPdf(row) {
      window.open(process.env.VUE_APP_OSS_URL + row.ossUrl);
    },
    handleAdd() {
      this.isUpdate = false
      this.ossUrl = "";
      this.platformId = "";
      this.projectId = ''
      this.pdfUrl = "";
      this.pdfName = "";
      // this.updateData.inputVersion = '1.00'
      this.selectRow = {};
      this.$set(this.updateData, "inputVersion", "1.00");
      this.$set(this.updateData, "id", "");
      this.$set(this.updateData, "text", "");
      this.$set(this.updateData, "content", "");
      this.$set(this.updateData, "type", "");
      this.$set(this.updateData, "doctorTeamId", "");
      this.doctorTeamList = []
      this.dialogFormVisible = true;
    },
    // 获取平台
    async querInitList() {
      let res = await getHospitalList({});
      if (res.code === 0) {
        this.hospitalList = res.data;
      }
      let res1 = await api_UserAgreementTypeEnum();
      if (res1.code === 0) {
        this.agreementTypeList = res1.data;
        this.agreementTypeArr = res1.data.map(v => v.name);
      }
    },
    getDoctorTeamIdList(query) {
      if (query !== '') {
        this.getDoctorTeamLoading = true;
        var params = {
          doctorTeamName: query,
        }
        api_doctor_team_search(params).then(res => {
          this.getDoctorTeamLoading = false;
          this.doctorTeamList = res.data.records
        })
      } else {
        this.doctorTeamList = [];
      }
    },
    beforeAvatarUpload(file) {
      let suffix =
        file.name.substring(file.name.lastIndexOf(".") + 1) === "pdf";
      if (!suffix) {
        this.$message.error("仅支持上传PDF格式的附件协议!");
      } else {
        this.pdfName = file.name;
      }
      return suffix;
    },
    handleChange(file) {
      this.pdfUrl = process.env.VUE_APP_OSS_URL + file.data;
      this.ossUrl = file.data;
      // this.checkFormData.pictureUrl = file.data
      // this.$forceUpdate()
      this.$message.success("上传成功");
    },
    async save() {
      let valStr;
      this.$refs.agreeForm.validateField(["inputVersion"], verifycode_check => {
        valStr = verifycode_check;
      });
      if (valStr) {
        return;
      }
      if (!this.platformId) {
        this.$message.warning("请选择对应平台");
        return;
      }
      if (!this.projectId) {
        this.$message.warning("请选择对应项目");
        return;
      }
      if (!this.updateData.type) {
        this.$message.warning("请选择协议类型");
        return;
      }
      if (this.updateData.type == 9) {
        if (!this.updateData.doctorTeamId) {
          this.$message.warning("请输入机构团队");
          return;
        }
      }
      if (!this.updateData.text || this.updateData.text === " ") {
        this.$message.warning("请填写协议内容");
        return;
      }
      if (this.updateData.type != 9) {
        this.updateData.doctorTeamId = null
      }
      if (this.updateData.id) {
        // 修改
        await api_update({
          id: this.updateData.id,
          text: this.updateData.text,
          platformId: this.platformId,
          project: this.projectId,
          ossUrl: this.ossUrl,
          pdfName: this.pdfName,
          type: this.updateData.type,
          doctorTeamId: this.updateData.doctorTeamId,
          version: this.updateData.inputVersion
        });
        this.dialogFormVisible = false;
        this.getList();
      } else {
        let res = await add_api_detail({
          id: this.updateData.id,
          text: this.updateData.text,
          platformId: this.platformId,
          project: this.projectId,
          ossUrl: this.ossUrl,
          pdfName: this.pdfName,
          type: this.updateData.type,
          doctorTeamId: this.updateData.doctorTeamId,
          version: this.updateData.inputVersion
        });
        if (res.code === 0) {
          this.$message.success("保存成功");
          this.dialogFormVisible = false;
          this.getList();
        }
      }
    },
    showUpdate(row) {
      this.isUpdate = true
      this.selectRow = DEEP_CLONE(row);
      this.updateData = DEEP_CLONE(row);
      // this.updateData.inputVersion = this.updateData.version
      this.$set(this.updateData, "inputVersion", this.updateData.version);
      this.$set(this.updateData, "content", row.text);
      this.doctorTeamList = []
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs.agreeForm.clearValidate(["inputVersion"]);
      });

      if (Number(row.platformId) === 0) {
        this.platformId = "";
      } else {
        this.platformId = row.platformId;
      }
      this.projectId = row.project
      this.ossUrl = row.ossUrl;
      this.pdfName = row.pdfName;
    },
    async getList() {
      let res = await api_list({});
      // res.data.forEach(v=>{
      //   v.type =typeMap.get(v.type);
      // })
      this.list = res.data;
    },
    insertImg(insertImgFn, result) {
      insertImgFn(process.env.VUE_APP_OSS_URL + result.url);
    },
    uploadImgError(xhr, editor, resData) {
    },
    insertVideo(insertVideoFn, result) {
      insertVideoFn(process.env.VUE_APP_OSS_URL + result.url);
    },
    uploadVideoError(xhr, editor, resData) {
    },
    contentChange(content) {
      this.$set(this.updateData, "text", content.content);
      this.$set(this.updateData, "content", content.content);
    }
  }
};
</script>

<style>
.pdf-column {
  display: flex;
  align-items: center;
}

.organization {
  padding: 0 24px 16px;
}
</style>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.add-item {
  // width: 100%;
  background-color: #fcfcfc;
  border: 1px dashed #d9d9d9;
  color: #333333;
  width: 247px;
  height: 35px;
}

.headerCom {
  .text {
    margin-bottom: 22px;
    color: #999999;
    font-size: 14px;
    line-height: 22px;
    padding-top: 20px;
  }
}

.organization-content-box {
  background: #fff;
  padding: 20px;
}

/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ .el-table--small th {
  background: #fafafa;
  border: none;
}

/deep/.el-table--border {
  border: none;
}

/deep/.el-table--border th {
  border: none;
  text-align: center;
  color: #333333;
  //   border-bottom: 1px solid #e9e9e9;
}

/deep/.el-table--border td {
  border-right: none;
  text-align: center;
  color: #333333;
  padding: 10.5px 0;
  border-bottom: 1px solid #e9e9e9;
}

/deep/.el-dialog__body {
  height: 70vh;
  padding-top: 0;
}
</style>
